const cache = new Map()
const inFlight = new Map()
const CACHE_TTL = 5 * 60 * 1000
const CONCURRENCY = 6

function getStoreKey() {
  return window.Trillion && window.Trillion.yotpoStoreId
}

function isEnabled() {
  return !!(window.Trillion && window.Trillion.yotpoEnabled && getStoreKey())
}

function getCached(sku) {
  var entry = cache.get(sku)
  if (entry && (Date.now() - entry.fetchedAt < CACHE_TTL)) {
    return entry
  }
  if (entry) cache.delete(sku)
  return null
}

function fetchRating(sku) {
  if (!isEnabled() || !sku) return Promise.resolve(null)

  var cached = getCached(sku)
  if (cached) return Promise.resolve(cached)

  if (inFlight.has(sku)) return inFlight.get(sku)

  var promise = fetch(
    'https://api-cdn.yotpo.com/v3/storefront/store/' + getStoreKey() + '/product/' + encodeURIComponent(sku) + '/ratings'
  )
    .then(function (response) {
      if (!response.ok) return null
      return response.json()
    })
    .then(function (data) {
      if (!data) return null
      var bottomline = data.bottomline || (data.response && data.response.bottomline)
      if (!bottomline) return null

      var result = {
        averageScore: bottomline.averageScore || 0,
        totalReviews: bottomline.totalReviews || 0,
        fetchedAt: Date.now()
      }
      cache.set(sku, result)
      return result
    })
    .catch(function () {
      return null
    })
    .then(function (result) {
      inFlight.delete(sku)
      return result
    })

  inFlight.set(sku, promise)
  return promise
}

function prefetchRatings(skus) {
  if (!isEnabled()) return Promise.resolve()

  var unique = skus.filter(function (s, i, arr) {
    return s && arr.indexOf(s) === i && !getCached(s)
  })

  function fetchChunk(startIndex) {
    if (startIndex >= unique.length) return Promise.resolve()
    var chunk = unique.slice(startIndex, startIndex + CONCURRENCY)
    return Promise.all(chunk.map(fetchRating)).then(function () {
      return fetchChunk(startIndex + CONCURRENCY)
    })
  }

  return fetchChunk(0)
}

export default { fetchRating: fetchRating, prefetchRatings: prefetchRatings, isEnabled: isEnabled, getCached: getCached }
